import React from 'react';
import { CustomDiv, DarkmodeCustomDataGrid } from './style';

const CustomizedTable = props => {
  return <CustomDiv>{<DarkmodeCustomDataGrid {...props} />}</CustomDiv>;
};

export default CustomizedTable;
